"use strict";
var tab_heading_directive_1 = require('./tabs/tab-heading.directive');
exports.TabHeadingDirective = tab_heading_directive_1.TabHeadingDirective;
var tabset_component_1 = require('./tabs/tabset.component');
exports.TabsetComponent = tabset_component_1.TabsetComponent;
var tab_directive_1 = require('./tabs/tab.directive');
exports.TabDirective = tab_directive_1.TabDirective;
var tabs_module_1 = require('./tabs/tabs.module');
exports.TabsModule = tabs_module_1.TabsModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/components/tabs.js
// module id = 1205
// module chunks = 0